import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
import { Table } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
import { fetchCallAllDataByIDAPI, filterCallByParams, getSingleDataFromDatabase } from '../../utils/api'
import ContentWrapper from '../../components/contentwrapper/ContentWrapper'
import withAuth from '../../utils/withAuth'


const ProcessDetails = () => {
    const [currentTime, setCurrentTime] = useState(new Date());
    const navigate = useNavigate();
    const ppcid = localStorage.getItem('ppcdata');
    const [ppc, setPPC] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [process, setProcess] = useState([]);
    const [searchSkill, setSearchSkill] = useState("");
    const [dateRange, setDateRange] = useState({
        startDate: new Date().toLocaleDateString('en-US'),
        endDate: new Date().toLocaleDateString('en-US'),
    });
    const [isCustomRange, setIsCustomRange] = useState(false);


    useEffect(() => {
        if (ppcid) {
            navigate('/process-details');
            getDashboardSingleEmpData(ppcid)
            getProcessDetails(ppcid);
            const interval = setInterval(() => setCurrentTime(new Date()), 1000);

            return () => clearInterval(interval);
        }
        else {
            navigate("/");
        }
    }, [ppcid]);

    const getDashboardSingleEmpData = async (ppcid) => {
        try {
            const res = await getSingleDataFromDatabase(`ppc-get-single-data/${ppcid}`);
            if (res?.data?.status === 1) {
                setPPC(res.data.ppcdata || {});
            } else {
                toast.error(res?.data?.message || "Failed to load PPC data");
            }
        } catch (err) {
            console.error(err);
            toast.error("Network/CORS error while loading PPC data");
        }
    };

    const getProcessDetails = async (ppcid) => {
        setIsLoading(true);
        try {
            const res = await fetchCallAllDataByIDAPI(`ppc-team-get-today-all-call-report/${ppcid}`);
            setIsLoading(false);
            if (res?.data?.status === 1) {
                setProcess(res.data.process || []);
            } else {
                toast.error(res?.data?.message || "Failed to load process");
            }
        } catch (err) {
            setIsLoading(false);
            console.error(err);
            toast.error("Network/CORS error while loading process");
        }
    };
    const filteredProcess = process.filter(item =>
        item.skillname.toLowerCase().includes(searchSkill.toLowerCase()) ||
        item.display.toLowerCase().includes(searchSkill.toLowerCase()) ||
        item.language.toLowerCase().includes(searchSkill.toLowerCase()) ||
        item.product.toLowerCase().includes(searchSkill.toLowerCase()) ||
        item.handle.toLowerCase().includes(searchSkill.toLowerCase())
    );

    const formattedTime = currentTime.toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
    const greeting = () => {
        const hour = currentTime.getHours();
        if (hour < 12) return "Good Morning";
        else if (hour < 17) return "Good Afternoon";
        return "Good Evening";
    };

    const totals = filteredProcess.reduce(
        (acc, item) => {
            acc.unique_calls += Number(item.unique_calls) || 0;
            acc.total_calls += Number(item.total_calls) || 0;
            acc.today_calls += Number(item.today_calls) || 0;
            acc.today_total_calls += Number(item.today_total_calls) || 0;
            return acc;
        },
        { unique_calls: 0, total_calls: 0, today_calls: 0, today_total_calls: 0 }
    );

    const handleFilterByDate = async (event, picker) => {
        setIsLoading(true);
        const start = picker.startDate.format("YYYY-MM-DD");
        const end = picker.endDate.format("YYYY-MM-DD");

        setDateRange({ startDate: start, endDate: end });
        setIsCustomRange(true);

        try {
            const res = await filterCallByParams('ppc-team-get-filter-all-call-report', {
                startDate: start, endDate: end, ppcid
            });
            if (res?.data?.status === 1) setProcess(res.data.process || []);
        } catch (error) {
            console.error(error);
            toast.error("Error fetching filtered report");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR::DASHBOARD</title>
            </Helmet>
            <ContentWrapper>
                <div className="d-flex justify-content-between">
                    <div>
                        <h4 className="dashboardname">
                            {greeting()}, <span>{ppc?.ppc_name}</span>
                        </h4>
                    </div>
                    <h4 style={{ fontWeight: 600 }}>⏰ {formattedTime}</h4>
                </div>

                {/* Leave Balance */}
                <div className="row mt-2">
                    <div className="col-12 col-lg-12 col-sm-6">
                        <div className="card hrpages">
                            <div className="heading p-2 d-flex justify-content-between">
                                <h5 className="mb-0 text-uppercase" style={{fontWeight:"600"}}>
                                    Process Details (
                                    {isCustomRange
                                        ? `${moment(dateRange.startDate).format("DD MMM YYYY")} - ${moment(dateRange.endDate).format("DD MMM YYYY")}`
                                        : "Last 30 Days"}
                                    )
                                </h5>
                                <div style={{ width: "25%" }}>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Skill Name, Language, Product and Handle By..."
                                        value={searchSkill}
                                        onChange={(e) => setSearchSkill(e.target.value)}
                                    />
                                </div>
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: dateRange.startDate,
                                        endDate: dateRange.endDate
                                    }}
                                    onApply={handleFilterByDate}
                                >
                                    <button className="btn btn-sm btndaterange">Select Date Range</button>
                                </DateRangePicker>
                            </div>
                            <div className="table pagetable table-responsive">
                                <Table className="table-sm table-fixeds" responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th colSpan={6} className="text-end" style={{ fontWeight: "700", fontSize: "14px", letterSpacing: "0.8px" }}>Grand Total</th>
                                            <th style={{ fontWeight: "700", fontSize: "14px", letterSpacing: "0.8px" }}>{totals.unique_calls}</th>
                                            <th style={{ fontWeight: "700", fontSize: "14px", letterSpacing: "0.8px" }}>{totals.total_calls}</th>
                                            <th style={{ fontWeight: "700", fontSize: "14px", letterSpacing: "0.8px" }}>{totals.today_calls}</th>
                                            <th style={{ fontWeight: "700", fontSize: "14px", letterSpacing: "0.8px" }}>{totals.today_total_calls}</th>
                                        </tr>
                                    </thead>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Skill Name</th>
                                            <th>Display</th>
                                            <th>Language</th>
                                            <th>Product</th>
                                            <th>Center</th>
                                            <th>Total Unique Call</th>
                                            <th>Total Call</th>
                                            <th>Today Unique Call</th>
                                            <th>Today Call</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? (
                                            [...Array(10)].map((_, i) => (
                                                <tr key={i}>
                                                    {Array.from({ length: 10 }).map((_, index) => (
                                                        <td key={index}>
                                                            <Skeleton animation="wave" variant="text" />
                                                        </td>
                                                    ))}
                                                </tr>
                                            ))
                                        ) : filteredProcess.length > 0 ? (
                                            filteredProcess.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>
                                                        <Link to={`/ppc-display-skill-details/${item.skillname}`} className="pcname">
                                                            {item.skillname}
                                                        </Link>
                                                    </td>
                                                    <td>{item.display}</td>
                                                    <td>{item.language}</td>
                                                    <td>{item.product}</td>
                                                    <td>{item.handle}</td>
                                                    <td>{item.unique_calls}</td>
                                                    <td>{item.total_calls}</td>
                                                    <td>{item.today_calls}</td>
                                                    <td>{item.today_total_calls}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={10} className="text-center">No matching skills found...</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End */}
            </ContentWrapper>
        </div>
    )
}

export default withAuth(ProcessDetails)